import {
  Button,
  Chip,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
  Select,
  SelectItem,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";

import React, { useEffect, useState } from "react";

import {
  getSingleCollectionData,
  PublishData,
  UpdateSingleCollectionData,
  getDataWithFilterUrl,
} from "../../controllers/APIController";
import {
  ApprovalWorkFlowDataSchemaObj,
  FieldList,
  FrameWorkDataSchemaObj,
  FrequecyCountMap,
  FrequencyDataObj,
} from "../../utils/constant";
import PreviewForm from "./PreviewForm";
import EnhancedPreviewForm from "./EnhancedPreviewForm";
import AddModal from "./AddModal";
import FieldInfoTable from "./FieldInfoTable";
import { useNavigate, useParams } from "react-router-dom";
import AddFormulaModal from "./AddFormulaModal";
import FormulaInfoTable from "./FormulaInfoTable";
import {
  CustomFrequencyInput,
  DropDownInput,
  MultiSelectInput,
} from "./InputField/InputField";
import MetricTagInput from "./InputField/MetricTagInput";
import useGetAllModels from "../../hooks/useGetAllModels";
import {
  getAllApproverOfOrgnization,
  getAllReviewerOfOrgnization,
  getAllUserOfOrgnization,
  getFieldInfoListFromGetJSonSchema,
  getLinkInfoListFromJson,
} from "../../utils/helper";
import {
  ApproverUserSchemaObj,
  AssignedToUserSchemaObj,
  ReviewerUserSchemaObj,
  sectorSchema,
} from "../../constant/FormBuilder/FormBuilderConstant";
import useGetSectorName from "../../hooks/useGetSectorName";
import useGetDefaultOrg from "../../hooks/useGetDefaultOrg";
import FrameworFieldAccodian from "./FrameworFieldAccodian";
import {
  getJSonSchemaFromFieldInfoList,
  getLinkJsonReponse,
  generateUniqueId,
} from "../../utils/frombuilder.utils";
import FormFieldArranger from "./FormFieldArranger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAltH, faColumns } from "@fortawesome/free-solid-svg-icons";

const initialFormData = {
  metricName: "",
  Category: "",
  className: "",
  description: "",
  frameWork: [],
  ApprovalWorkFlow: "Default",
  SectorText: "",
  preferredLayout: "2-column", // Default to 2-column layout
};

const UIMetricBuilderValidation = (
  formData,
  fieldInfoList,
  requiredArr,
  allMetricName
) => {
  const err = {};
  let isValid = true;



  if (fieldInfoList.length === 0) {
    err["BuildData"] = "Build Data should have atleast one field";
    isValid = false;
  }
  
  // Allow copying by checking if the name ends with "(Copy)"
  const metricName = formData["metricName"]?.trim()?.toLowerCase();
  const isCopying = metricName?.endsWith("(copy)");
  
  if (allMetricName?.includes(metricName) && !isCopying) {
    err["metricName"] = "Metric Name already have been used";
    isValid = false;
  }

  Object.keys(formData).forEach((key) => {
    if (requiredArr.includes(key) && formData[key] === "") {
      err[key] = `${key} is required`;
      isValid = false;
    }
  });
  
  return { isValid: isValid, error: err };
};

const UIFormBuilder = ({ metricInfo, isCopying = false }) => {
  const navigator = useNavigate();
  const { _orgId } = useParams();

  const { allModels, setAllModels } = useGetAllModels();
  const [loader, setLoader] = useState(true);
  const [initialDataLoading, setInitialDataLoading] = useState(true);
  const { allSectorName } = useGetSectorName();
  const { OrgDetail: DefaultOrgDetail } = useGetDefaultOrg();
  
  // Initialize formData before useEffect that references it
  const [formData, setFormData] = useState(initialFormData);
  
  // Set default sector when sectors are loaded
  useEffect(() => {
    if (allSectorName?.length && !formData.SectorText) {
      const generalSector = allSectorName.find(sector => 
        sector.name?.toLowerCase() === "general"
      );
      const defaultSector = generalSector || allSectorName[0];
      if (defaultSector) {
        setFormData(prev => ({
          ...prev,
          SectorText: defaultSector.name
        }));
      }
    }
  }, [allSectorName, formData.SectorText]);

  // Get organization info for API calls
  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;

  // Fetch categories on component mount
  useEffect(() => {
    fetchCategories();
  }, [OrgInfo]);

  const [allMetricName, setAllMetricName] = useState([]);
  const [frameWorkList, setFrameWorkList] = useState([]);
  const [frameWorkDetails, setFrameWorkDetails] = useState({});
  const [MetricNameList, setMetricNameList] = useState({
    TCFD: "",
    BRSR: "",
    SASB: "",
    GRI: "",
  });


  const [frequency, setFrequency] = useState(FrequencyDataObj?.values[0]?.name);
  const [customFrequency, setCustomFrequency] = useState(0.01);

  const showCustomFrequencyInput = frequency === "Custom";

  const [validationErrors, setValidationErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [isOpenArranger, setIsOpenArranger] = useState(false);

  const [fieldType, setFieldType] = useState(""); // field type that we want to create
  const [fieldInfoList, setFieldInfoList] = useState([]); // JsonSchema Input field info
  const [LinkInfoList, setLinkInfoList] = useState([]); // Link field info in Metric
  const [selectedFormulaList, setSelectedFormulaList] = useState([]);
  const [FormulaInfoList, setFormulaInfoList] = useState([]); // Link field info in Metric

  const [selectedAssignedTo, setSelectedAssignedTo] = useState([]);
  const [selectedApproverTo, setSelectedApproverTo] = useState([]);
  const [selectedReviewerTo, setSelectedReviewerTo] = useState([]);
  const [AllUserList, setAllUserList] = useState([]);
  const [AllApproverList, setAllApproverList] = useState([]);
  const [AllReviewerList, setAllReviewerList] = useState([]);

  const [tags, setTags] = useState([]);
  const [allTags, setAllTags] = useState([]);

  const [tagsValidation, setTagsValidation] = useState("");

  // Dynamic category state
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isOpenLink,
    onOpen: onOpenLink,
    onOpenChange: onOpenChangeLink,
  } = useDisclosure();

  const {
    isOpen: isOpenFormula,
    onOpen: onOpenFormula,
    onOpenChange: onOpenChangeFormula,
  } = useDisclosure();

  const requiredArr = [
    "metricName",
    "Category",
    "jsonSchema",
    "ApprovalWorkFlow",
  ];

  const FrameWorkDataSchema = FrameWorkDataSchemaObj;
  FrameWorkDataSchema.values = frameWorkList;

  // Fetch categories from metrics API
  const fetchCategories = async () => {
    if (!OrgInfo) return;
    
    setIsLoadingCategories(true);
    try {
      const data = await getDataWithFilterUrl("metrics", orgFilterUrl);
      const metricsList = data?.data || [];
      
      // Extract unique categories from metrics data
      const uniqueCategories = [...new Set(
        metricsList.map(item => item?.attributes?.Category).filter(Boolean)
      )].sort();
      
      // Convert to the format expected by the dropdown
      const categoriesList = uniqueCategories.map((category, index) => ({
        id: (index + 1).toString(),
        name: category,
      }));
      
      setDynamicCategories(categoriesList);
    } catch (error) {
      console.error("Error fetching categories:", error);
      // Fallback to empty array if API fails
      setDynamicCategories([]);
    } finally {
      setIsLoadingCategories(false);
    }
  };

  const fieldListValues = Object.keys(FieldList).map((key) => [key, FieldList[key]]);
  const changeHandler = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const showPreviewHandler = () => {
    setShowPreview(false);
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr,
      allMetricName
    );

    setValidationErrors(validationResponse.error);
    if (!validationResponse.isValid) {
      return;
    }

    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );
    const frameWorkResponse = { id: formData?.frameWork || [] };

    const publishData = {
      Name: formData.metricName,
      Category: formData.Category,
      ClassName: formData.className,
      Description: formData.description,
      WorkFlow: formData.ApprovalWorkFlow,
      Framework: frameWorkResponse,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      FrequencyValue:
        frequency === "Custom" ? +customFrequency : FrequecyCountMap[frequency],
      Organization: OrgInfo,
    };

    setPreviewData(publishData);
    setShowPreview(true);
  };

  const submitHandler = async () => {
    const validationResponse = UIMetricBuilderValidation(
      formData,
      fieldInfoList,
      requiredArr,
      allMetricName
    );

    if (!validationResponse.isValid) {
      setValidationErrors(validationResponse.error);
      return;
    }
    const JsonSchemaData = getJSonSchemaFromFieldInfoList(
      fieldInfoList,
      FormulaInfoList
    );
    const frameWorkResponse = { id: formData?.frameWork || [] };
    const AssignedToData = selectedAssignedTo?.map((id) => +id);
    const ApproverToData = selectedApproverTo?.map((id) => +id);
    const ReviewerToData = selectedReviewerTo?.map((id) => +id);

    const moreInfo = {
      NameList: { ...MetricNameList, Generic: formData?.metricName },
    };

    const publishData = {
      Name: formData.metricName,
      Category: formData.Category,
      ClassName: formData.className,
      Description: formData.description,
      Sector: formData.SectorText,
      WorkFlow: formData.ApprovalWorkFlow,
      Framework: frameWorkResponse,
      JsonSchema: JsonSchemaData,
      Links: getLinkJsonReponse(LinkInfoList),
      FrequencyValue:
        frequency === "Custom" ? +customFrequency : FrequecyCountMap[frequency],
      TagList: tags,
      Organization: OrgInfo,
      AssignedTo: AssignedToData,
      ApproverTo: ApproverToData,
      ReviewerTo: ReviewerToData,
      ...moreInfo,
    };

    let result = await PublishData({ data: publishData }, "metrics");

    const newTags = tags?.filter((name) => !allTags?.includes(name));
    const updatedTags = [...allTags, ...newTags];
    await UpdateSingleCollectionData("tag", { List: updatedTags });

    navigator(`/${_orgId}/metrics-builder`);
  };

  const addFieldHandler = (listItem) => {
    // Ensure new fields get proper displayOrder
    const newField = {
      ...listItem,
      displayOrder: fieldInfoList.length
    };
    setFieldInfoList([...fieldInfoList, newField]);
  };

  const addLinkHandler = (listItem) => {
    setLinkInfoList([...LinkInfoList, listItem]);
  };
  const addFormulaHandler = (listItem) => {
    setFormulaInfoList([...FormulaInfoList, listItem]);
  };

  const handleSaveArrangement = (arrangementData) => {
    // Update fieldInfoList with the new arrangement
    const updatedFieldInfoList = arrangementData.fields.map(field => ({
      ...fieldInfoList.find(f => f.id === field.id),
      visualOrder: field.visualOrder,
      size: field.size
    })).sort((a, b) => a.visualOrder - b.visualOrder);
    
    setFieldInfoList(updatedFieldInfoList);
    
    // Update form data with layout preferences
    setFormData(prev => ({
      ...prev,
      preferredLayout: arrangementData.preferredLayout,
      containerWidth: arrangementData.containerWidth,
      fieldSizes: arrangementData.fieldSizes
    }));
    
    // Save to database if needed
    // You can also save this to your backend here if needed
    // For example, update the form schema in the database
  };

  useEffect(() => {
    // Combine all API calls to reduce loading time
    const loadInitialData = async () => {
      try {
        // Execute all API calls in parallel for better performance
        const [
          frameworksData,
          metricsData,
          tagsData,
          usersData,
          reviewersData,
          approversData
        ] = await Promise.all([
          getDataWithFilterUrl("frameworks"),
          getDataWithFilterUrl("metrics", orgFilterUrl),
          getSingleCollectionData("tag"),
          getAllUserOfOrgnization(),
          getAllReviewerOfOrgnization(),
          getAllApproverOfOrgnization()
        ]);

        // Process frameworks
        let frameWorkData = frameworksData.data;
        const f = {};
        frameWorkData = frameWorkData?.map((item) => {
          f[item.id] = item.attributes.Name;
          return { id: item.id, name: item?.attributes?.Name };
        });
        setFrameWorkDetails(f);
        setFrameWorkList(frameWorkData);

        // Set default framework to "General" if it exists, otherwise use first available
        const generalFramework = frameWorkData?.find(item => 
          item.name?.toLowerCase() === "general"
        );
        const defaultFramework = generalFramework || frameWorkData?.[0];
        if (defaultFramework && !formData.frameWork?.length) {
          setFormData(prev => ({
            ...prev,
            frameWork: [defaultFramework.id]
          }));
        }

        // Process metrics
        const metricsList = metricsData?.data?.map((a) => {
          return a?.attributes?.Name.trim().toLowerCase();
        });
        setAllMetricName(metricsList);

        // Process tags
        setAllTags(tagsData?.data?.attributes?.List || []);

        // Process users
        const processedUsers = usersData?.map((user) => ({
          id: user.id,
          name: user.username
        }));
        const processedReviewers = reviewersData?.map((user) => ({
          id: user.id,
          name: user.username
        }));
        const processedApprovers = approversData?.map((user) => ({
          id: user.id,
          name: user.username
        }));

        setAllUserList(processedUsers);
        setAllApproverList(processedApprovers);
        setAllReviewerList(processedReviewers);

        setInitialDataLoading(false);
      } catch (err) {
        console.error("Error loading initial data:", err);
        setInitialDataLoading(false);
      }
    };

    loadInitialData();
  }, [orgFilterUrl]);

  useEffect(() => {
    let response = metricInfo;

    if (!response) {
      return;
    }

    // If copying, modify the name to indicate it's a copy
    const metricName = isCopying 
      ? `${response?.attributes?.Name || ""} (Copy)`
      : response?.attributes?.Name || "";

    setFormData({
      metricName: metricName,
      Category: response?.attributes?.Category || "",
      className: response?.attributes?.ClassName || "",
      description: response?.attributes?.Description || "",
      frameWork: response?.attributes?.Framework?.id || [],
      ApprovalWorkFlow: response?.attributes?.WorkFlow,
      SectorText: response?.attributes?.Sector || "",
    });
    const AssignedToData = response?.attributes?.AssignedTo?.data?.map((user) =>
      user?.id?.toString()
    );
    const ApproverToData = response?.attributes?.ApproverTo?.data?.map((user) =>
      user?.id?.toString()
    );
    const ReviewerToData = response?.attributes?.ReviewerTo?.data?.map((user) =>
      user?.id?.toString()
    );
    setSelectedAssignedTo(AssignedToData);
    setSelectedApproverTo(ApproverToData);
    setSelectedReviewerTo(ReviewerToData);

    const frequencyNumber = +response?.attributes?.FrequencyValue;
    const frequencyval =
      frequencyNumber === -1
        ? "Custom"
        : frequencyNumber === 30
        ? "Every month"
        : frequencyNumber === 7
        ? "Every week"
        : frequencyNumber === 1
        ? "Everyday"
        : "Only Once";

    setFrequency(frequencyval);

    const fieldInfoList = getFieldInfoListFromGetJSonSchema(
      response?.attributes?.JsonSchema
    );
    console.log("UIFormBuilder - Generated fieldInfoList:", fieldInfoList);
    setFieldInfoList(fieldInfoList);
    setLinkInfoList(
      getLinkInfoListFromJson(response?.attributes?.Links?.Links)
    );

    setFormulaInfoList(response?.attributes?.JsonSchema?.formula || []);
    setTags(response?.attributes?.TagList || []);
    let formulaList = response?.attributes?.JsonSchema?.formula || [];
    formulaList = formulaList.map((data) => data?.id?.toString());
    setSelectedFormulaList(formulaList);

    setMetricNameList(response?.attributes?.NameList || {});
    setLoader(false);
  }, [metricInfo]);

  if (initialDataLoading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading form builder...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start justify-between my-2">
      <div className="flex flex-col items-center w-[50%]">
        {/* Metric Name Input  */}
        <Input
          type="text"
          className="my-8"
          variant="faded"
          isRequired
          label="Metric Name"
          labelPlacement="outside"
          placeholder=" "
          name="metricName"
          onChange={changeHandler}
          value={formData["metricName"]}
          isInvalid={validationErrors["metricName"]}
          errorMessage={
            validationErrors["metricName"] && validationErrors["metricName"]
          }
        />
        {isCopying && formData["metricName"] && (
          <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-amber-800 text-sm">
              💡 <strong>Copying:</strong> You can modify the metric name above. The "(Copy)" suffix has been added automatically.
            </p>
          </div>
        )}

        {/* Category DropDown */}

        <DropDownInput
          buttonCSS={"mb-8"}
          data={{
            id: "category",
            name: "Drop Down",
            type: "dropdown",
            title: "Category",
            values: dynamicCategories,
            required: true,
            ismultiselect: false,
          }}
          value={formData?.Category === "" ? "" : formData.Category}
          validationErrors={validationErrors}
          onChangeHandler={(title, value, type) =>
            setFormData({
              ...formData,
              Category: value,
            })
          }
        />

        {/* ClassName Input */}
        <Input
          type="text"
          className="my-4"
          variant="faded"
          label="Class Name"
          placeholder=" "
          labelPlacement="outside"
          name="className"
          onChange={changeHandler}
          value={formData["className"]}
        />

        {/* Description Input  */}
        <Textarea
          label="Description"
          labelPlacement="outside"
          variant="faded"
          className="my-4"
          name="description"
          onChange={changeHandler}
          value={formData["description"]}
        />



        {DefaultOrgDetail?.id === OrgInfo && (
          <DropDownInput
            data={{
              ...sectorSchema,
              values: allSectorName,
            }}
            value={formData?.SectorText}
            validationErrors={validationErrors}
            onChangeHandler={(title, value, type) =>
              setFormData({ ...formData, SectorText: value })
            }
            buttonCSS="mb-4"
          />
        )}

        {/* FrameWork Input */}

        {formData?.Category?.toLowerCase() !== "reference data" && (
          <Select
            label="Select Framework"
            placeholder="Select any Framework"
            variant="faded"
            selectionMode="multiple"
            labelPlacement="outside"
            className="my-6"
            selectedKeys={new Set((Array.isArray(formData["frameWork"]) ? formData["frameWork"] : []).filter(id => {
              const exists = frameWorkList?.some(item => item.id.toString() === id.toString());
              if (!exists) {
                console.warn(`Framework ID ${id} not found in frameWorkList:`, frameWorkList?.map(item => item.id));
              }
              return exists;
            }) || [])}
            onSelectionChange={(event) =>
              setFormData({
                ...formData,
                frameWork: Array?.from(event) || [],
              })
            }
          >
            {frameWorkList?.map((item) => (
              <SelectItem key={item.id} value={item.name} className="py-2">
                {item.name}
              </SelectItem>
            ))}
          </Select>
        )}

        {formData?.Category?.toLowerCase() !== "reference data" &&
          formData?.frameWork &&
          formData?.frameWork?.map((id, index) => {
            return (
              <FrameworFieldAccodian
                key={`framework-${id}-${index}`}
                title={frameWorkDetails[+id]}
                setMetricNameList={setMetricNameList}
                MetricNameList={MetricNameList}
              />
            );
          })}

        {/* AssignedTo User DropDown */}
        <MultiSelectInput
          data={AssignedToUserSchemaObj}
          value={selectedAssignedTo}
          valuesList={AllUserList}
          onChangeHandler={(title, value, type) => setSelectedAssignedTo(value)}
        />

        {/* Approval Workfflow DropDown */}
        <DropDownInput
          buttonCSS={"mb-8"}
          data={ApprovalWorkFlowDataSchemaObj}
          value={formData?.ApprovalWorkFlow || ""}
          validationErrors={validationErrors}
          onChangeHandler={(title, value, type) =>
            setFormData({
              ...formData,
              ApprovalWorkFlow: value,
            })
          }
        />

        {/* Approver User DropDown */}
        {(formData?.ApprovalWorkFlow === "1-Step Approval" ||
          formData?.ApprovalWorkFlow === "2-Step Approval") && (
          <MultiSelectInput
            data={ApproverUserSchemaObj}
            value={selectedApproverTo}
            valuesList={AllApproverList}
            onChangeHandler={(title, value, type) =>
              setSelectedApproverTo(value)
            }
          />
        )}
        {/* Reviewer User DropDown */}
        {formData?.ApprovalWorkFlow === "2-Step Approval" && (
          <MultiSelectInput
            data={ReviewerUserSchemaObj}
            value={selectedReviewerTo}
            valuesList={AllReviewerList}
            onChangeHandler={(title, value, type) =>
              setSelectedReviewerTo(value)
            }
          />
        )}

        {/* Frequency DropDown */}

        <DropDownInput
          buttonCSS={"mb-8"}
          data={FrequencyDataObj}
          value={frequency}
          validationErrors={1}
          onChangeHandler={(title, value, type) => setFrequency(value)}
        />

        {showCustomFrequencyInput && (
          <CustomFrequencyInput
            value={customFrequency}
            onChangeHandler={(value) => setCustomFrequency(value)}
          />
        )}

        {/* Metrics Tags Input */}
        <MetricTagInput
          tags={tags}
          setTags={setTags}
          IntialvalidationError={tagsValidation}
          allTags={allTags}
        />

        {/* Formula Input */}

        {/* <Select
          label="Select Formulae"
          placeholder="Choose any Formulae"
          variant="faded"
          selectionMode="multiple"
          labelPlacement="outside"
          className="my-8"
          selectedKeys={new Set(selectedFormulaList)}
          onSelectionChange={(event) => {
            setSelectedFormulaList(Array.from(event));
          }}
        >
          {allModels?.map((item) => (
            <SelectItem key={item.id} value={item.id} className="py-2">
              {item.title}
            </SelectItem>
          ))}
        </Select> */}

        {/* JsonSchema Input */}

        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Build your Metric Schema</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Choose a data type and begin building your metric forms.
          </p>

          {/* Form Layout Preference */}
          <div className="mb-4 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-2 mb-3">
              <FontAwesomeIcon icon={faColumns} className="text-gray-600" />
              <span className="font-medium">Default Form Layout</span>
            </div>
            <p className="text-sm text-gray-600 mb-3">
              Choose how your form fields will be arranged by default. You can always change this later using the "Arrange Fields" feature.
            </p>
            <div className="flex gap-3">
              <Button
                size="sm"
                variant={formData.preferredLayout === "2-column" ? "solid" : "bordered"}
                color={formData.preferredLayout === "2-column" ? "primary" : "default"}
                onPress={() => setFormData({ ...formData, preferredLayout: "2-column" })}
                startContent={<FontAwesomeIcon icon={faColumns} />}
                className="flex-1"
              >
                <div className="text-left">
                  <div className="font-medium">2-Column Layout</div>
                  <div className="text-xs text-gray-500">Fields arranged in a grid</div>
                </div>
              </Button>
              <Button
                size="sm"
                variant={formData.preferredLayout === "1-column" ? "solid" : "bordered"}
                color={formData.preferredLayout === "1-column" ? "primary" : "default"}
                onPress={() => setFormData({ ...formData, preferredLayout: "1-column" })}
                startContent={<FontAwesomeIcon icon={faColumns} />}
                className="flex-1"
              >
                <div className="text-left">
                  <div className="font-medium">1-Column Layout</div>
                  <div className="text-xs text-gray-500">Fields stacked vertically</div>
                </div>
              </Button>
            </div>
          </div>

          <div className="flex justify-end my-4 mr-4 gap-2">
            <Button
              size="sm"
              variant="bordered"
              onPress={() => setIsOpenArranger(true)}
              className="border-emerald-300 hover:border-emerald-400 text-emerald-700 hover:text-emerald-800 px-6 font-medium"
              startContent={<FontAwesomeIcon icon={faArrowsAltH} className="text-sm" />}
            >
              Preview & Arrange
            </Button>
            <Dropdown>
              <DropdownTrigger>
                <Button 
                  color="primary" 
                  size="sm"
                  className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
                >
                  Add a new field
                </Button>
              </DropdownTrigger>
              <DropdownMenu
                aria-label="Static Actions"
                selectionMode="single"
                onSelectionChange={(event) => {
                  const selectedKey = Array.from(event)[0];
                  // Ensure we have a valid field type
                  if (selectedKey && FieldList[selectedKey]) {
                    setFieldType(selectedKey);
                    onOpen();
                  } else {
                    console.error("Invalid field type selected:", selectedKey);
                  }
                }}
              >
                {fieldListValues.map(
                  (row, index) =>
                    row[1].name !== "linkUrl" && (
                      <DropdownItem key={row[0]} name={row[0]}>
                        {row[1].title}
                      </DropdownItem>
                    )
                )}
              </DropdownMenu>
            </Dropdown>
          </div>

          {isOpen && (
            <AddModal
              onSubmitHandler={addFieldHandler}
              isOpen={isOpen}
              onOpen={onOpen}
              onOpenChange={onOpenChange}
              fieldType={fieldType}
              id={generateUniqueId('field')}
              frameWorkDetails={frameWorkDetails}
              frameWorkList={frameWorkList}
              category={formData?.Category}
              existingFields={fieldInfoList}
            />
          )}

          <FieldInfoTable
            fieldInfoList={fieldInfoList}
            setFieldInfoList={setFieldInfoList}
            frameWorkDetails={frameWorkDetails}
            frameWorkList={frameWorkList}
          />
        </div>

        {/* Links Input */}
        {/*
        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Attach your reference links</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Attach reference links for users to fill your metrics easier
          </p>

          <div className="flex justify-end my-4 mr-4">
            <Button 
              size="sm" 
              onClick={() => onOpenLink()}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
            >
              Add a new link
            </Button>
          </div>

          {isOpenLink && (
            <AddModal
              onSubmitHandler={addLinkHandler}
              // id={deleteMetricId}
              modalHeading={"Are you sure you want to delete this Entry?"}
              isOpen={isOpenLink}
              onOpen={onOpenLink}
              onOpenChange={onOpenChangeLink}
              fieldType="link"
              id={generateUniqueId('link')}
            />
          )}

          <FieldInfoTable
            fieldInfoList={LinkInfoList}
            setFieldInfoList={setLinkInfoList}
            headersList={["Name", "Link", ""]}
          />
        </div>
        */}

        {/* Formula Input */}

        <div className="w-full min-h-96">
          <div className="flex items-center gap-4">
            <p className="text-lg font-medium">Design your Formula</p>
          </div>
          {validationErrors["BuildData"] && (
            <p className="text-[#f76497]">{validationErrors["BuildData"]}</p>
          )}
          <p className="my-4 text-sm">
            Design your formula to handle mathematical calculations like
            emissions, diversity and many more.
          </p>

          <div className="flex justify-end my-4 mr-4">
            <Button 
              color="primary" 
              size="sm" 
              onClick={() => onOpenFormula()}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium"
            >
              Add a new formula
            </Button>
          </div>

          {isOpenFormula && (
            <AddFormulaModal
              onSubmitHandler={addFormulaHandler}
              isOpen={isOpenFormula}
              onOpen={onOpenFormula}
              onOpenChange={onOpenChangeFormula}
              fieldType="formula"
              id={generateUniqueId('formula')}
            />
          )}

          <FormulaInfoTable
            fieldInfoList={FormulaInfoList}
            setFieldInfoList={setFormulaInfoList}
          />
        </div>
        {/* Preview,Submit button */}
        <div className="flex gap-4 justify-end w-full pt-6">
          <Button
            color="default"
            variant="bordered"
            size="sm"
            onClick={showPreviewHandler}
            className="px-6"
          >
            Preview
          </Button>
          <Button 
            color="primary" 
            size="sm" 
            className="px-6 bg-emerald-600 hover:bg-emerald-700"
            onClick={submitHandler}
          >
            Submit
          </Button>
        </div>
      </div>

      {/* Preview Card Open */}
      {showPreview && (
        <div className="flex flex-col items-center w-[48%]">
          <EnhancedPreviewForm data={previewData} fieldInfoList={fieldInfoList} />
        </div>
      )}

      {/* Form Field Arranger Modal */}
      <FormFieldArranger
        fieldInfoList={fieldInfoList}
        onSaveArrangement={handleSaveArrangement}
        isOpen={isOpenArranger}
        onOpenChange={setIsOpenArranger}
        preferredLayout={formData.preferredLayout}
        formData={formData}
      />
    </div>
  );
};

export default UIFormBuilder;
